import { Link } from 'react-router-dom';

const footerLinks = {
  '浏览内容': [
    { label: '电影', path: '/category/dianying' },
    { label: '电视剧', path: '/category/dianshiju' },
    { label: '综艺', path: '/category/zongyi' },
    { label: '动漫', path: '/category/dongman' },
  ],
  '关于我们': [
    { label: '品牌介绍', path: '/about' },
    { label: '用户口碑', path: '/about#testimonials' },
    { label: '联系我们', path: '/about#contact' },
  ],
  '帮助支持': [
    { label: '常见问题', path: '/#faq' },
    { label: '观影指南', path: '/article/5' },
    { label: '意见反馈', path: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="container-custom py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-play-circle-fill text-3xl text-accent-500" style={{ fontSize: '32px' }}></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50 whitespace-nowrap">番茄视频</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              您的随身高清影院。提供海量高清电影、电视剧、综艺、动漫免费在线观看，流畅不缓冲，极致画质体验。
            </p>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                {category}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2020-2026 番茄视频 版权所有 | 京ICP备2020000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}